import { Box, useTheme } from "@mui/material";
import NavBar from "../../Components/NavBar";
import Landing from "../../Sections/Landing";
import Work from "../../Sections/Work";
import "../../../src/index.css";
import { useCycle } from "framer-motion";
const blob = require("../../assets/magicpattern-blob-1710787651582.png");
const blob2 = require("../../assets/magicpattern-blob-1710781780794.png");
const blob3 = require("../../assets/magicpattern-blob-1710781848351.png");

const Home = () => {
  const theme = useTheme();
  const [isOpen, toggleOpen] = useCycle(false, true);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%)",
          position: "relative",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            maxWidth: "2000px",
            width: "100%",
            margin: "0 auto",
            position: "relative",
          }}
        >
          <NavBar onToggle={toggleOpen} />
          <Landing />

          <Box
            component="img"
            src={blob2}
            alt=""
            aria-hidden="true"
            sx={{
              height: "clamp(220px, 32vw, 500px)",
              width: "clamp(220px, 32vw, 500px)",
              zIndex: 0,
              position: "absolute",
              animation: "floatSideways 8s ease-in-out infinite",
              filter: "blur(8px)",
              maskImage: "radial-gradient(circle, #000 15%, transparent 50%)",
              WebkitMaskImage:
                "radial-gradient(circle, #000 15%, transparent 50%)",
              opacity: 0.7,
              left: "clamp(-140px, -8vw, -40px)",
              bottom: "10%",
              pointerEvents: "none",
            }}
          />
          <Box
            component="img"
            src={blob3}
            alt=""
            aria-hidden="true"
            sx={{
              height: "clamp(220px, 32vw, 500px)",
              width: "clamp(280px, 40vw, 700px)",
              zIndex: 0,
              position: "absolute",
              filter: "blur(8px)",
              maskImage: "radial-gradient(circle, #000 15%, transparent 50%)",
              WebkitMaskImage:
                "radial-gradient(circle, #000 15%, transparent 50%)",
              opacity: 0.7,
              right: "clamp(-160px, -10vw, -60px)",
              animation: "float 7s ease-in-out infinite",
              top: "clamp(-80px, -8vw, -20px)",
              pointerEvents: "none",
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          maxWidth: "2000px",
          width: "100%",
          margin: "0 auto",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={blob}
          alt=""
          aria-hidden="true"
          sx={{
            height: "clamp(180px, 26vw, 500px)",
            width: "clamp(180px, 26vw, 500px)",
            position: "absolute",
            zIndex: 0,
            filter: "blur(8px)",
            maskImage: "radial-gradient(circle, #000 15%, transparent 50%)",
            WebkitMaskImage:
              "radial-gradient(circle, #000 15%, transparent 50%)",
            opacity: 0.7,
            right: "clamp(-60px, 4vw, 120px)",
            bottom: "clamp(-90px, -10vh, 20px)",
            pointerEvents: "none",
            [theme.breakpoints.down(700)]: {
              bottom: "-35px",
            },
          }}
        />
      </Box>
      {!isOpen && <Work onToggle={toggleOpen} />}
    </Box>
  );
};

export default Home;
